import { sourceDisplayName } from './sourceDisplayName';

/** Shared source filter options for Activity, pipeline, and search debug views. */
export const SOURCE_FILTER_OPTIONS: ReadonlyArray<{ value: string; label: string }> = [
  { value: '', label: 'All sources' },
  { value: 'autoscout24', label: sourceDisplayName('autoscout24') },
  { value: 'kleinanzeigen', label: sourceDisplayName('kleinanzeigen') },
  { value: 'mobile_de', label: sourceDisplayName('mobile_de') },
  { value: 'njuskalo', label: sourceDisplayName('njuskalo') },
];
